/*============Popup Controller
  ================================*/
  angular
    .module('vppApp')
    .controller('SendEmailController', SendEmailController);
// agregar SummaryGeneralFactory  - Account service
  SendEmailController.$inject = ['$scope', '$rootScope', '$compile', '$sce'];

  function SendEmailController($scope, $rootScope, $compile, $sce){

    // <-----SHARE EMAIL TEMPLATES----->
    // TODO: Ensure *required* validation works on "message" textarea. Is a contenteditable div and not an actual form field and therefore probably needs to be addressed separate from other fields
    // TODO: Separate this content to JSON files and create factory+service to bring back in
      $rootScope.emailFamily = {
        yourEmail: '',
        theirEmail: '',
        subject: 'Use my GM Employee Discount to save',
        message: 'Family means sharing the best things in life. One of the great things about working for GM is having a significant vehicle discount to share. The next time you’re shopping for a new car, truck or SUV, let me know — I may be able to get you a GM Employee Discount authorization number that will help you save hundreds, even thousands, on a great new Chevrolet, Buick, GMC or Cadillac. You can even combine my GM Employee Discount with most current offers for an even better deal. Want to build your dream vehicle and see how my discount saves you below MSRP? Visit gmfamilyfirst.com or https://www.gmfamilyfirst.com/offers/ to see current lease flyers from each GM division.'
      };
      $rootScope.emailFriend = {
        yourEmail: '',
        theirEmail: '',
        subject: 'Use my GM discount to save',
        message: 'Helping out friends is a good feeling. One of the great things about working for GM is having a significant vehicle discount to share. The next time you’re shopping for a new car, truck or SUV, let me know — I’ll get you a GM Supplier Discount for Friends authorization number that will help you save hundreds, even thousands, on a great new Chevrolet, Buick, GMC or Cadillac. You can even combine the GM Supplier Discount for Friends with current offers for an even better offer. Want to build your dream vehicle and see how my discount saves you below MSRP? Visit gmfamilyfirst.com or https://www.gmsupplierdiscount.com/offers/ to see featured savings examples from each GM division.'
      };
      $sce.trustAsHtml($rootScope.emailFriend.message);

      // // <-------------- Send email with RENDERED html to default email app --------------->
      //
      // // Ajoiner: The code below is incomplete as the customer has decided to withgo formatted email content
      // // FOR NOW. It is left here with the intention of completing the "Email -> Angular.HTML.object"
      // // functionality upon the client's future request.
      //
      // // TODO: change email modal subject field from textarea to div: <div contenteditable="true" id="emailFamily.message" class="textArea" data-ng-model="emailFamily.message | sanitize" name="textField" autofocus="autofocus" type="text" autocapitalize="off" autocorrect="off" tabindex="0" required>
      // // TODO: change below functions from $scope to $rootScope to properly trigger mailto: link / native email client???
      //
      // // populate 'email' var with Family Email contents
      // $scope.sendFamilyEmail = function(emailId,subject,message){
      //   var emailContents = "mailto:"+ $rootScope.emailFamily.friendsEmail + "?subject=" + $rootScope.emailFamily.subject+"&body="+$rootScope.emailFamily.message,"_self";
      //   $scope.sendEmail(emailContents);
      // };
      // // populate 'email' var with Friend Email contents
      // $scope.sendFriendEmail = function(emailId,subject,message){
      //   var emailContents = "mailto:"+ $rootScope.friend.friendsEmail + "?subject=" + $rootScope.friend.subject+"&body="+$rootScope.friend.message,"_self";
      //   $scope.sendEmail(emailContents);
      // };
      // // construct angular.element out of 'email' var contents
      // $scope.sendEmail = function(){
      //   $scope.modalToggle;  // NOTE: <-- This line originally had two semi-colons (;;), this might be what was breaking functionality
      //   $scope.sendEmail = function(data){
      //     var scope = angular.extend($scope.$new(), {
      //         user: {
      //             email: 'user@user.com'
      //         }
      //     });
      //
      //     var email = angular.element(data);
      //     $compile(data)(scope);
      //
      //     scope.$apply();
      //     $window.open(email.html());
      //   }; // </-------------- Send email with RENDERED html to default email app --------------->
    };
